<ng-container *ngFor="let item of items; let i = index">
  <mat-divider *ngIf="item.divider"></mat-divider>

  <!-- Feuille (lien direct) -->
  <button
    *ngIf="!item.children?.length && isVisible(item)"
    mat-menu-item
    [routerLink]="item.link"
    [disabled]="item.disabled"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: false }"
  >
    <mat-icon *ngIf="item.icon" fontSet="material-symbols-outlined">{{
      item.icon
    }}</mat-icon>
    <span>{{ item.label }}</span>
  </button>

  <!-- Dossier (sous-menu) -->
  <button
    *ngIf="item.children?.length && isVisible(item)"
    mat-menu-item
    [matMenuTriggerFor]="subMenuRef"
    [disabled]="item.disabled"
  >
    <mat-icon *ngIf="item.icon" fontSet="material-symbols-outlined">{{
      item.icon
    }}</mat-icon>
    <span>{{ item.label }}</span>
    <span style="flex: 1"></span>
    <!-- <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon> -->
  </button>

  <mat-menu #subMenuRef="matMenu" [overlapTrigger]="false">
    <app-menu-branch
      [items]="item.children || []"
      [roles]="roles"
    ></app-menu-branch>
  </mat-menu>
</ng-container>
